// extracted by mini-css-extract-plugin
export var description = "style-module--description--iBCFN";
export var fontsLoading = "style-module--fonts-loading--idPHO";
export var info = "style-module--info--XWGcY";
export var speakerAvatar = "style-module--speakerAvatar--URLc3";
export var speakerBackgroundImg = "style-module--speakerBackgroundImg--eDuEk";
export var speakerImgContainer = "style-module--speakerImgContainer--nuCE6";
export var speakerItemWrapper = "style-module--speakerItemWrapper--PLoEN";
export var speakerSmallListWrapper = "style-module--speakerSmallListWrapper--jFn+b";